module.exports = __webpack_public_path__ + "static/media/img-02.c81f640a.jpg";